import '../static/QuotesCarousel.css';
import React__default from "react";
import clsx from "clsx";
import { C as Col } from "./Col.COJSUXXS.mjs";
import { a as SectionWrap } from "./SectionWrap.DExzuSui.mjs";
import { b as SectionHeader } from "./SectionHeader.VCo9GnTI.mjs";
import { S as Slider } from "./Slider.CQuUmyJh.mjs";
import { b as Quote } from "./Quote.BPj0dqrC.mjs";
import { b as breakpoints } from "./sword.DtiKVPhx.mjs";
const quotesCarousel = `_quotesCarousel_f8faa7c`;
const gradient = `_gradient_83206e1`;
const header = `_header_e83c7ca`;
const slider = `_slider_028071b`;
const styles = { quotesCarousel, gradient, header, slider };
const CAROUSEL_QUOTE_VARIANT = ["client", "member"];
const QuotesCarousel = ({
  className,
  sectionHeader,
  quoteList,
  backgroundGradient = true,
  variant = "client",
  ...props
}) => {
  if (!quoteList.length) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement(
    SectionWrap,
    {
      className: clsx(
        styles.quotesCarousel,
        styles[variant],
        {
          [styles.gradient]: backgroundGradient
        },
        className
      ),
      "data-ui-quotes-carousel": true,
      "data-testid": "ui-quotes-carousel",
      ...props
    },
    sectionHeader && /* @__PURE__ */ React__default.createElement(
      SectionHeader,
      {
        ...sectionHeader,
        className: styles.header,
        "data-testid": "ui-section-header"
      }
    ),
    /* @__PURE__ */ React__default.createElement(Col, { lg: 8, md: 12, sm: 12 }, /* @__PURE__ */ React__default.createElement(
      Slider,
      {
        className: styles.slider,
        ...{
          autoplayTimer: 7800,
          pagination: true,
          grabCursor: true,
          loop: true,
          slidesPerView: 1,
          spaceBetween: 12,
          breakpoints: {
            [parseInt(breakpoints.minMd)]: {
              spaceBetween: 24
            },
            [parseInt(breakpoints.minLg)]: {
              spaceBetween: 32
            }
          }
        },
        slides: quoteList.map((quote, index) => /* @__PURE__ */ React__default.createElement(Quote, { key: index, variant, ...quote }))
      }
    ))
  );
};
export {
  CAROUSEL_QUOTE_VARIANT as C,
  QuotesCarousel as Q
};
//# sourceMappingURL=QuotesCarousel.yNRSA-Tn.mjs.map
